import { Component } from '@angular/core';

@Component({
    selector: 'backend-vr-section',
    templateUrl: './vr-section.component.html',
    styleUrls: ['./vr-section.component.css'],
    standalone: false
})
export class VrSectionComponent {
  public contactInfo = ['ies-support.func@siemens-healthineers.com'];
}
